import { Observable } from 'rxjs/Observable';
import { CccSocketProvider } from './../../providers/ccc-socket/ccc-socket';
import { CoinsProvider } from './../../providers/coins/coins';
import { CoinSearchComponent } from './../coin-search/coin-search';
import { Coin } from './../../models/Coin';
import { ViewController, ModalController, AlertController, ToastController } from 'ionic-angular';
import { Component } from '@angular/core';
import { NavController } from '../../../node_modules/ionic-angular/navigation/nav-controller';
import { SignalsProvider } from '../../providers/signals/signals';
import { UserProvider } from '../../providers/user/user';
import { Grade, newGrade } from '../../models/Grade';
import { GradesProvider } from '../../providers/grades/grades';

@Component({
    selector: 'add-grade',
    templateUrl: 'add-grade.html'
})
export class AddGradeComponent {

    coin: Coin;
    grade: Grade;
    editMode: boolean = false;
    newGrade: boolean = false;

    isAdmin: Observable<boolean>;

    possibleOverall: String[] = ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'];

    constructor(
        public viewCtrl: ViewController,
        public navCtrl: NavController,
        public modalCtrl: ModalController,
        public coinCtrl: CoinsProvider,
        public socket: CccSocketProvider,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public gradesCtrl: GradesProvider,
        public userCtrl: UserProvider
    ) {

        this.isAdmin = this.userCtrl.isAdmin();

        //Set up editor if param passed in
        let grade: Grade = this.viewCtrl.getNavParams().get('grade');
        let isStock = this.viewCtrl.getNavParams().get('isStock') || false;
        if (grade) {
            this.coinCtrl
                .getCoinByName(grade.coin)
                .first()
                .subscribe(coin => {
                    this.coin = coin;
                    this.grade = grade;
                });

        } else { //Otherwise set up a new grade to create
            this.newGrade = true;
            this.grade = newGrade(isStock);
        }
    }

    selectCoin() {
        let modal = this.modalCtrl.create(CoinSearchComponent);
        modal.present();
        modal.onDidDismiss((coin: Coin) => {
            if (coin) {
                this.coin = coin;
                this.grade.coin = this.coin.Name;
            }
        })
    }

    formatSats(price: number): string {
        const formatter = new Intl.NumberFormat('en-US', { style: 'decimal', maximumFractionDigits: 0 });
        return formatter.format(price);
    }

    removeGrade() {
        const alert = this.alertCtrl.create({
            title: `Delete Grade`,
            subTitle: `Are you sure you want to delete this Grade? You really shouldn't do this unless you've made a mistake.`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.gradesCtrl.removeGrade(this.grade).then(val => {
                            this.toastCtrl.create({ message: 'Grade Deleted', duration: 2000 }).present();
                            this.dismiss();
                        });
                    }
                }
            ]
        })
        alert.present();
    }
    saveGrade() {
        const alert = this.alertCtrl.create({
            title: `Save Grade`,
            subTitle: `Are you sure you want to save this grade?`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.gradesCtrl.editGrade(this.grade).then(val => {
                            this.toastCtrl.create({ message: 'Grade Saved', duration: 2000 }).present();
                            this.dismiss();
                        });
                    }
                }
            ]
        })
        alert.present();
    }

    publishGrade() {

        const alert = this.alertCtrl.create({
            title: `Publish Grade`,
            subTitle: `Are you sure you are ready to publish this grade? Might wanna double check.`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.grade.timestamp = (new Date).getTime();
                        this.gradesCtrl.addGrade(this.grade).then(val => {
                            this.toastCtrl.create({ message: 'Grade Published', duration: 2000 }).present();
                        });
                        this.dismiss();
                    }
                }
            ]
        })
        alert.present();
    }

    getGainClass(gain: number): string {
        if (gain > 0) {
            return 'target';
        } else if (gain < 0) {
            return 'stop';
        } else {
            return '';
        }
    }

    getTotalScore() {
        return (this.grade.buyRating || 0)
            + (this.grade.growth || 0)
            + (this.grade.utility || 0)
            + (this.grade.risk || 0)
            + (this.grade.volatility || 0);
    }

    getParagraphs(input: string) {
        if (input) {
            return input.split('\n');
        }
        return [];
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/components/add-grade/add-grade.ts